module.exports = __webpack_public_path__ + "assets/fase-swap-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/fase-swap-icon.svg
// module id = 325
// module chunks = 0